import {
  FormControl,
  FormHelperText,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  TextField,
  Grid,
} from '@mui/material'
import React from 'react'
import { categorySelectOptions } from '../../../../../constant/Event'
import { Event } from '../../../../../redux/event/manageEvents/types'

interface EventDetailsProps {
  handleChange: (
    eventOrValue:
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      | SelectChangeEvent<string>
      | Date,
    fieldName?: string,
  ) => void
  formData: Partial<Event>
  error: {
    title: string
    details: string
    estimatedBudget: string
    targetCompliance: string
    category: string
    type: string
  }
}

const EventDetails: React.FC<EventDetailsProps> = ({ handleChange, formData, error }) => {
  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    handleChange(event)
  }

  return (
    <Grid container spacing={2} direction='column'>
      <Grid>
        <TextField
          id='title'
          name='title'
          required
          label='Event Title'
          value={formData.title ?? ''}
          onChange={handleChange}
          placeholder='Enter event title'
          helperText={error.title}
          error={!!error.title}
          fullWidth
        />
      </Grid>
      <Grid>
        <TextField
          id='details'
          name='details'
          required
          label='Event Details'
          value={formData.details ?? ''}
          onChange={handleChange}
          placeholder='Enter details about the event'
          multiline
          helperText={error.details}
          error={!!error.details}
          rows={4}
          fullWidth
        />
      </Grid>
      <Grid container spacing={2} direction='row'>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            fullWidth
            id='estimated-budget'
            label='Estimated Budget'
            value={formData.estimatedBudget ?? ''}
            name='estimatedBudget'
            onChange={handleChange}
            helperText={error.estimatedBudget}
            error={!!error.estimatedBudget}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <FormControl variant='outlined' required fullWidth error={!!error.targetCompliance}>
            <InputLabel htmlFor='target-compliance' error={!!error.targetCompliance}>
              Target Compliance
            </InputLabel>
            <OutlinedInput
              id='target-compliance'
              endAdornment={<InputAdornment position='end'>%</InputAdornment>}
              label='Target Compliance'
              value={formData.targetCompliance ?? ''}
              name='targetCompliance'
              onChange={handleChange}
              // onBlur={handleBlur}
              error={!!error.targetCompliance}
            />
            <FormHelperText error={!!error.targetCompliance}>{error.targetCompliance}</FormHelperText>
          </FormControl>
        </Grid>
      </Grid>
      <Grid container spacing={2} direction='row'>
        <Grid size={{ xs: 12, md: 6 }}>
          <FormControl fullWidth required error={!!error.category}>
            <InputLabel id='event-category' error={!!error.category}>
              Event Category
            </InputLabel>
            <Select
              name='category'
              labelId='event-category'
              value={formData.category ?? ''}
              label='Event Category'
              onChange={handleSelectChange}
              // onBlur={handleBlur}
              error={!!error.category}
              inputProps={{
                id: 'event-category-select-input',
              }}
            >
              {Object.entries(categorySelectOptions).map(([key, category]) => (
                <MenuItem key={key} value={key} id={category.id}>
                  {category.label}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText error={!!error.category}>{error.category}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <FormControl
            fullWidth
            required={
              formData.category !== undefined &&
              formData.category !== '' &&
              formData.category in categorySelectOptions &&
              categorySelectOptions[formData.category]?.eventTypeSelectOptions?.length > 0
            }
            disabled={
              formData.category === undefined ||
              formData.category === '' ||
              !(formData.category in categorySelectOptions) ||
              categorySelectOptions[formData.category]?.eventTypeSelectOptions?.length === 0
            }
            error={!!error.type}
          >
            <InputLabel id='type' error={!!error.type}>
              Event Type
            </InputLabel>
            <Select
              labelId='type'
              inputProps={{
                id: 'type',
              }}
              value={formData.type ?? ''}
              label='Event Type'
              onChange={handleSelectChange}
              // onBlur={handleBlur}
              name='type'
              error={!!error.type}
            >
              {formData.category &&
                categorySelectOptions[formData.category]?.eventTypeSelectOptions?.map((option) => (
                  <MenuItem key={option.id} value={option.label} id={option.id}>
                    {option.label}
                  </MenuItem>
                ))}
            </Select>
            <FormHelperText error={!!error.type}>{error.type}</FormHelperText>
          </FormControl>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default EventDetails
